import React, { createContext, useContext, useState } from "react";

const AdminContext = createContext();

export const useAdmin = () => useContext(AdminContext);

export const AdminProvider = ({ children }) => {
  // Initialise synchronously from localStorage so a page reload does not momentarily
  // render as unauthenticated (which would bounce the user off protected routes).
  const initial = typeof window !== "undefined" ? localStorage.getItem("adminPassword") : null;
  const [password, setPassword] = useState(initial || null);
  const [isAuthenticated, setIsAuthenticated] = useState(!!initial);

  const login = (pwd) => {
    localStorage.setItem("adminPassword", pwd);
    setPassword(pwd);
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem("adminPassword");
    setPassword(null);
    setIsAuthenticated(false);
  };

  return (
    <AdminContext.Provider value={{ password, isAuthenticated, login, logout }}>
      {children}
    </AdminContext.Provider>
  );
};

export default AdminContext;
